<template>
  <div>
    <div class="my-2">
      <b-collapse id="collapse-1" class="mt-2" v-model="visibleCollapse">
        <b-card>
          <b-form v-on:submit.prevent>
            <b-form-group id="input-group-2" label="Código del descriptor:" label-for="input-2">
              <b-form-input
                id="input-2"
                v-model="newDescriptor.id"
                placeholder="Código"
                disabled
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="input-group-1"
              label="Descriptor:"
              label-for="textarea"
            >
              <b-form-textarea
                id="textarea"
                v-model="newDescriptor.description"
                placeholder="Ingrese el descriptor"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>

            <b-button variant="primary" @click="validateDescriptor()">{{ newDescriptor.id ? 'Guardar edición' : 'Guardar'}}</b-button>
            <b-button variant="light" class="btn-sm" @click="cancel()">Cancelar</b-button>
          </b-form>
        </b-card>
      </b-collapse>
    </div>
    <a-divider v-if="doesEdit" orientation="left">Lista de descriptores creados
      <b-button variant="primary" @click="create()" style="position: absolute; right: 2rem; top: -0.5em; z-index: 1;">Crear</b-button>
    </a-divider>
    <div class="my-2">
      <b-container>
        <h5 v-if="!doesEdit" class="mb-4">
          <strong>Lista de descriptores creados</strong>
        </h5>
        <div class="mb-2">
          <b-form inline v-on:submit.prevent="getDescriptorList()">
            <b-form-input
              id="inline-form-input-descriptor"
              class="mb-2 mr-sm-2 mb-sm-0"
              placeholder="Código/Descriptor"
              v-model="search"
            ></b-form-input>
            <b-button variant="primary" type="submit">Buscar</b-button>
            <b-button variant="light" class="btn-sm" @click="clean()">Cancelar</b-button>
            <label for="checkbox-1" class="ml-2">Solo yo puedos propios</label>
            <b-form-checkbox class="ml-2" id="checkbox-4" name="checkbox-4" switch v-model="own"></b-form-checkbox>
          </b-form>
        </div>
        <b-table striped hover :fields="columns" :items="descriptorList" head-variant="light" responsive v-show="descriptorList.length > 0">
          <!-- <template #cell(name)="user">
            {{ (user.item.name + ' ' + user.item.lastName) }}
          </template>
          <template #cell(nivel)="user">
            <number-rate v-model.number="user.item.nivel" v-b-tooltip.hover :title="user.item.lastName" :size="1.5" :min="1" :max="4"/>
          </template> -->
          <template #cell(actions)="data">
            <b-link v-if="doesEdit" @click="editDescriptor(data.item)">Editar</b-link><br v-if="doesEdit">
            <b-link v-else @click="selectDescriptor(data.item)">Seleccionar</b-link>
          </template>
        </b-table>
        <empty-table v-show="descriptorList.length === 0"/>
        <b-row>
          <b-col>
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.rows"
              :per-page="pagination.perPage"
              @input="getDescriptorList()"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
          <b-col class="text-right">
            {{ pagination.rows }} resultados
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-modal id="coincidences" no-enforce-focus scrollable ref="modal" hide-header hide-footer size="lg" @hidden="onHidden">
      <b-row class="my-3" align-h="center">
        <b-col cols="4">
          <label for="textarea-default"><b>¡Se han encontrado coincidencias!</b></label>
        </b-col>
      </b-row>
      <b-table striped hover :fields="columnsCoincidences" :items="coincidences" head-variant="light" responsive v-show="descriptorList.length > 0">
      </b-table>
      <b-row align-h="end">
        <b-col cols="3" align-self="end">
          <b-button size="sm" variant="primary" @click="saveDescriptor()" class="mr-2 mb-3 mt-3">Guardar de todas formas</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import apiClient from '@/services/axios'
import Swal from 'sweetalert2'
import emptyTable from '@/components/custom/cardEmptyList'
import { showErrorMessage } from '@/services/utilities/index'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'descriptor',
  components: {
    emptyTable,
  },
  props: {
    doesEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visibleCollapse: false,
      columns: [
        { key: 'id', label: 'Código' },
        { key: 'description', label: 'Descriptor' },
        { key: 'actions', label: 'Acciones' },
      ],
      columnsCoincidences: [
        { key: 'id', label: 'Código' },
        { key: 'description', label: 'Descriptor' },
      ],
      descriptorList: [],
      newDescriptor: {
        id: '',
        description: '',
      },
      pagination: {
        rows: 0,
        perPage: 5,
        currentPage: 1,
      },
      coincidences: [],
      search: '',
      own: false,
    }
  },
  created: function () {
    console.log('created')
    this.getDescriptorList()
  },
  mounted: function () {
    console.log('mounted')
  },
  updated: function () {
    console.log('updated')
  },
  beforeDestroy: function () {
    console.log('beforeDestroy')
  },
  methods: {
    getDescriptorList() {
      let q = ''
      if (this.search) {
        q += '&search=' + this.search
      }
      if (this.own) {
        q += '&own=' + this.own
      }
      apiClient.get(`/descriptors?page=${this.pagination.currentPage - 1}&perpage=${this.pagination.perPage + q}`, this.form).then(response => {
        this.descriptorList = response.data.results.rows
        this.pagination.rows = response.data.results.count
      }).catch(err => {
        Toast.fire({
          icon: 'warning',
          title: 'Ooops ocurrio un error \n' + showErrorMessage(err),
        })
      })
    },
    clean() {
      this.search = ''
      this.getDescriptorList()
    },
    validateDescriptor() {
      this.newDescriptor.description = this.newDescriptor.description.trim()
      if (this.newDescriptor.description.length < 10) {
        Toast.fire({
          icon: 'warning',
          title: 'La descripción del descriptor debe tener almenos 10 caracteres.',
        })
        return
      }
      if (this.newDescriptor.id) { // Ya existe el id entonces se edita
        this.saveEditIcan()
      } else { // Se crea por primera vez
        apiClient.get('/descriptors/checkDescriptor?description=' + this.newDescriptor.description).then(response => {
          if (response.data.value) {
            this.coincidences = response.data.descriptors
            this.$bvModal.show('coincidences')
          } else {
            this.saveDescriptor()
          }
        }).catch(err => {
          Toast.fire({
            icon: 'warning',
            title: 'Ooops ocurrio un error ' + showErrorMessage(err),
          })
        })
      }
    },
    saveEditIcan() {
      apiClient.patch('/descriptors/' + this.newDescriptor.id, this.newDescriptor).then(response => {
        Toast.fire({
          icon: 'success',
          title: `Se modificó el descriptor con el código ${response.data.id} correctamente.`,
        })
        this.getDescriptorList()
        this.visibleCollapse = false
      }).catch(err => {
        Toast.fire({
          icon: 'warning',
          title: 'Ooops ocurrio un error ' + showErrorMessage(err),
        })
      })
    },
    saveDescriptor() {
      apiClient.post('/descriptors', this.newDescriptor).then(response => {
        this.newDescriptor.id = response.data.id
        Toast.fire({
          icon: 'success',
          title: `Descriptor creado correctamente con el código ${response.data.id}.`,
        })
        this.getDescriptorList()
        this.$bvModal.hide('coincidences')
        this.visibleCollapse = false
      }).catch(err => {
        Toast.fire({
          icon: 'warning',
          title: 'Ooops ocurrio un error ' + showErrorMessage(err),
        })
      })
    },
    cancel() { // Boton cancelar
      this.newDescriptor = {
        id: '',
        description: '',
      }
      this.visibleCollapse = false
    },
    create() { // Boton crear
      this.newDescriptor = {
        id: '',
        description: '',
      }
      this.visibleCollapse = !this.visibleCollapse
    },
    editDescriptor(descriptor) {
      this.newDescriptor = descriptor
      this.visibleCollapse = true
    },
    selectDescriptor(descriptor) {
      // TODO no dejar editar si no lo creo (al menos que pueda por rol)
      // TODO axios para guardar el descriptor (Tener en cuenta en la api la validaación para no repetir el yo puedo)
      // TODO MENSAJE DE QUE SE AGREGO CORRECTAMENTE
      this.$parent.$parent.$parent.recieveDescriptor(descriptor)
    },
    onHidden() {
      this.coincidences = []
    },
  },
  watch: {
    own: function () {
      this.getDescriptorList()
    },
  },
}
</script>
